import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useHdrDetails = (schoolId: number, academicId: number) => {
  return trpc.hdr.getHdrDetails.useQuery(
    { schoolId, academicId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!schoolId && !!academicId,
    },
  );
};
